import { Controller } from "@hotwired/stimulus"
import { hasMatch } from "fzy.js"
import { debounceAnimationFrame } from "../helpers"

export default class extends Controller {
  static targets = ["field", "item", "link"]

  initialize() {
    this.filter = debounceAnimationFrame(this.filter.bind(this))
  }

  navigate(event) {
    const distance = { ArrowDown: 1, ArrowUp: -1 }[event.key]
    if (!distance) return
    event.preventDefault()

    const elements = this.itemTargets.filter((e) => !e.hidden)
    const oldIndex = elements.findIndex((e) => e.contains(document.activeElement))
    const newIndex = (oldIndex + distance + elements.length) % elements.length

    elements[newIndex]?.querySelector("a,button")?.focus()
  }

  filter() {
    const query = this.fieldTarget.value.trim()
    for (const item of this.itemTargets) {
      item.hidden = !matchItem(item, query)
    }
    for (const link of this.linkTargets) {
      const url = new URL(link.href)
      query ? url.searchParams.set("q", query) : url.searchParams.delete("q")
      link.href = url
    }
  }
}

function matchItem(item, query, { search } = item.dataset) {
  return query && (!search || hasMatch(query, search))
}
